export function splitFilename(filename: string): { name: string; extension: string } {
  if (filename == null) {
    return { name: '', extension: '' };
  }

  const dotIndex = filename.lastIndexOf('.');

  if (dotIndex === -1) {
    return { name: filename, extension: '' }; // Return the whole filename if there's no dot
  } else if (dotIndex === 0) {
    const extension = filename.substring(dotIndex + 1);
    return { name: '', extension: extension }; // Return an empty filename with an extension if it starts with a dot
  }

  const name = filename.substring(0, dotIndex);
  const extension = filename.substring(dotIndex + 1);

  return { name, extension };
}
